/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteRouteImport } from './routes/_app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as InviteTokenRouteImport } from './routes/invite/$token'
import { Route as AppSplatRouteImport } from './routes/app/$'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppMessagesRouteImport } from './routes/_app/messages'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppCalendarRouteImport } from './routes/_app/calendar'
import { Route as AppSignaturesRouteRouteImport } from './routes/_app/signatures/route'
import { Route as AppSettingsRouteRouteImport } from './routes/_app/settings/route'
import { Route as AppRequestsRouteRouteImport } from './routes/_app/requests/route'
import { Route as AppClientsRouteRouteImport } from './routes/_app/clients/route'
import { Route as AppSignaturesIndexRouteImport } from './routes/_app/signatures/index'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppRequestsIndexRouteImport } from './routes/_app/requests/index'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients/index'
import { Route as AppArtifactsIndexRouteImport } from './routes/_app/artifacts/index'
import { Route as AppSignaturesSplatRouteImport } from './routes/_app/signatures/$'
import { Route as AppSettingsShowcaseRouteImport } from './routes/_app/settings/showcase'
import { Route as AppSettingsPrivacyRouteImport } from './routes/_app/settings/privacy'
import { Route as AppSettingsMembersRouteImport } from './routes/_app/settings/members'
import { Route as AppSettingsIntegrationsRouteImport } from './routes/_app/settings/integrations'
import { Route as AppSettingsBillingRouteImport } from './routes/_app/settings/billing'
import { Route as AppRequestsRequestIdRouteImport } from './routes/_app/requests/$requestId'
import { Route as AppClientsClientIdRouteImport } from './routes/_app/clients/$clientId'

const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/app/',
  path: '/app/',
  getParentRoute: () => rootRouteImport,
} as any)
const InviteTokenRoute = InviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSplatRoute = AppSplatRouteImport.update({
  id: '/app/$',
  path: '/app/$',
  getParentRoute: () => rootRouteImport,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMessagesRoute = AppMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCalendarRoute = AppCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSignaturesRouteRoute = AppSignaturesRouteRouteImport.update({
  id: '/signatures',
  path: '/signatures',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRequestsRouteRoute = AppRequestsRouteRouteImport.update({
  id: '/requests',
  path: '/requests',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppClientsRouteRoute = AppClientsRouteRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSignaturesIndexRoute = AppSignaturesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSignaturesRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppRequestsIndexRoute = AppRequestsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRequestsRouteRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppClientsRouteRoute,
} as any)
const AppArtifactsIndexRoute = AppArtifactsIndexRouteImport.update({
  id: '/artifacts/',
  path: '/artifacts/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSignaturesSplatRoute = AppSignaturesSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AppSignaturesRouteRoute,
} as any)
const AppSettingsShowcaseRoute = AppSettingsShowcaseRouteImport.update({
  id: '/showcase',
  path: '/showcase',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsPrivacyRoute = AppSettingsPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsMembersRoute = AppSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsIntegrationsRoute = AppSettingsIntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsBillingRoute = AppSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppRequestsRequestIdRoute = AppRequestsRequestIdRouteImport.update({
  id: '/$requestId',
  path: '/$requestId',
  getParentRoute: () => AppRequestsRouteRoute,
} as any)
const AppClientsClientIdRoute = AppClientsClientIdRouteImport.update({
  id: '/$clientId',
  path: '/$clientId',
  getParentRoute: () => AppClientsRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/onboarding': typeof OnboardingRoute
  '/clients': typeof AppClientsRouteRouteWithChildren
  '/requests': typeof AppRequestsRouteRouteWithChildren
  '/settings': typeof AppSettingsRouteRouteWithChildren
  '/signatures': typeof AppSignaturesRouteRouteWithChildren
  '/calendar': typeof AppCalendarRoute
  '/dashboard': typeof AppDashboardRoute
  '/messages': typeof AppMessagesRoute
  '/notifications': typeof AppNotificationsRoute
  '/app/$': typeof AppSplatRoute
  '/invite/$token': typeof InviteTokenRoute
  '/app/': typeof AppIndexRoute
  '/clients/$clientId': typeof AppClientsClientIdRoute
  '/requests/$requestId': typeof AppRequestsRequestIdRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/privacy': typeof AppSettingsPrivacyRoute
  '/settings/showcase': typeof AppSettingsShowcaseRoute
  '/signatures/$': typeof AppSignaturesSplatRoute
  '/artifacts/': typeof AppArtifactsIndexRoute
  '/clients/': typeof AppClientsIndexRoute
  '/requests/': typeof AppRequestsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/signatures/': typeof AppSignaturesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRoute
  '/onboarding': typeof OnboardingRoute
  '/calendar': typeof AppCalendarRoute
  '/dashboard': typeof AppDashboardRoute
  '/messages': typeof AppMessagesRoute
  '/notifications': typeof AppNotificationsRoute
  '/app/$': typeof AppSplatRoute
  '/invite/$token': typeof InviteTokenRoute
  '/app': typeof AppIndexRoute
  '/clients/$clientId': typeof AppClientsClientIdRoute
  '/requests/$requestId': typeof AppRequestsRequestIdRoute
  '/settings/billing': typeof AppSettingsBillingRoute
  '/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/settings/members': typeof AppSettingsMembersRoute
  '/settings/privacy': typeof AppSettingsPrivacyRoute
  '/settings/showcase': typeof AppSettingsShowcaseRoute
  '/signatures/$': typeof AppSignaturesSplatRoute
  '/artifacts': typeof AppArtifactsIndexRoute
  '/clients': typeof AppClientsIndexRoute
  '/requests': typeof AppRequestsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/signatures': typeof AppSignaturesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteRouteWithChildren
  '/auth': typeof AuthRoute
  '/onboarding': typeof OnboardingRoute
  '/_app/clients': typeof AppClientsRouteRouteWithChildren
  '/_app/requests': typeof AppRequestsRouteRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteRouteWithChildren
  '/_app/signatures': typeof AppSignaturesRouteRouteWithChildren
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/messages': typeof AppMessagesRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/app/$': typeof AppSplatRoute
  '/invite/$token': typeof InviteTokenRoute
  '/app/': typeof AppIndexRoute
  '/_app/clients/$clientId': typeof AppClientsClientIdRoute
  '/_app/requests/$requestId': typeof AppRequestsRequestIdRoute
  '/_app/settings/billing': typeof AppSettingsBillingRoute
  '/_app/settings/integrations': typeof AppSettingsIntegrationsRoute
  '/_app/settings/members': typeof AppSettingsMembersRoute
  '/_app/settings/privacy': typeof AppSettingsPrivacyRoute
  '/_app/settings/showcase': typeof AppSettingsShowcaseRoute
  '/_app/signatures/$': typeof AppSignaturesSplatRoute
  '/_app/artifacts/': typeof AppArtifactsIndexRoute
  '/_app/clients/': typeof AppClientsIndexRoute
  '/_app/requests/': typeof AppRequestsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/signatures/': typeof AppSignaturesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/auth'
    | '/onboarding'
    | '/clients'
    | '/requests'
    | '/settings'
    | '/signatures'
    | '/calendar'
    | '/dashboard'
    | '/messages'
    | '/notifications'
    | '/app/$'
    | '/invite/$token'
    | '/app/'
    | '/clients/$clientId'
    | '/requests/$requestId'
    | '/settings/billing'
    | '/settings/integrations'
    | '/settings/members'
    | '/settings/privacy'
    | '/settings/showcase'
    | '/signatures/$'
    | '/artifacts/'
    | '/clients/'
    | '/requests/'
    | '/settings/'
    | '/signatures/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/onboarding'
    | '/calendar'
    | '/dashboard'
    | '/messages'
    | '/notifications'
    | '/app/$'
    | '/invite/$token'
    | '/app'
    | '/clients/$clientId'
    | '/requests/$requestId'
    | '/settings/billing'
    | '/settings/integrations'
    | '/settings/members'
    | '/settings/privacy'
    | '/settings/showcase'
    | '/signatures/$'
    | '/artifacts'
    | '/clients'
    | '/requests'
    | '/settings'
    | '/signatures'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/auth'
    | '/onboarding'
    | '/_app/clients'
    | '/_app/requests'
    | '/_app/settings'
    | '/_app/signatures'
    | '/_app/calendar'
    | '/_app/dashboard'
    | '/_app/messages'
    | '/_app/notifications'
    | '/app/$'
    | '/invite/$token'
    | '/app/'
    | '/_app/clients/$clientId'
    | '/_app/requests/$requestId'
    | '/_app/settings/billing'
    | '/_app/settings/integrations'
    | '/_app/settings/members'
    | '/_app/settings/privacy'
    | '/_app/settings/showcase'
    | '/_app/signatures/$'
    | '/_app/artifacts/'
    | '/_app/clients/'
    | '/_app/requests/'
    | '/_app/settings/'
    | '/_app/signatures/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRoute: typeof AuthRoute
  OnboardingRoute: typeof OnboardingRoute
  AppSplatRoute: typeof AppSplatRoute
  InviteTokenRoute: typeof InviteTokenRoute
  AppIndexRoute: typeof AppIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/app'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof InviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/$': {
      id: '/app/$'
      path: '/app/$'
      fullPath: '/app/$'
      preLoaderRoute: typeof AppSplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/messages': {
      id: '/_app/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/signatures': {
      id: '/_app/signatures'
      path: '/signatures'
      fullPath: '/signatures'
      preLoaderRoute: typeof AppSignaturesRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/requests': {
      id: '/_app/requests'
      path: '/requests'
      fullPath: '/requests'
      preLoaderRoute: typeof AppRequestsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/clients': {
      id: '/_app/clients'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof AppClientsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/signatures/': {
      id: '/_app/signatures/'
      path: '/'
      fullPath: '/signatures/'
      preLoaderRoute: typeof AppSignaturesIndexRouteImport
      parentRoute: typeof AppSignaturesRouteRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/requests/': {
      id: '/_app/requests/'
      path: '/'
      fullPath: '/requests/'
      preLoaderRoute: typeof AppRequestsIndexRouteImport
      parentRoute: typeof AppRequestsRouteRoute
    }
    '/_app/clients/': {
      id: '/_app/clients/'
      path: '/'
      fullPath: '/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppClientsRouteRoute
    }
    '/_app/artifacts/': {
      id: '/_app/artifacts/'
      path: '/artifacts'
      fullPath: '/artifacts/'
      preLoaderRoute: typeof AppArtifactsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/_app/signatures/$': {
      id: '/_app/signatures/$'
      path: '/$'
      fullPath: '/signatures/$'
      preLoaderRoute: typeof AppSignaturesSplatRouteImport
      parentRoute: typeof AppSignaturesRouteRoute
    }
    '/_app/settings/showcase': {
      id: '/_app/settings/showcase'
      path: '/showcase'
      fullPath: '/settings/showcase'
      preLoaderRoute: typeof AppSettingsShowcaseRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/privacy': {
      id: '/_app/settings/privacy'
      path: '/privacy'
      fullPath: '/settings/privacy'
      preLoaderRoute: typeof AppSettingsPrivacyRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/members': {
      id: '/_app/settings/members'
      path: '/members'
      fullPath: '/settings/members'
      preLoaderRoute: typeof AppSettingsMembersRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/integrations': {
      id: '/_app/settings/integrations'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof AppSettingsIntegrationsRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/settings/billing': {
      id: '/_app/settings/billing'
      path: '/billing'
      fullPath: '/settings/billing'
      preLoaderRoute: typeof AppSettingsBillingRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/_app/requests/$requestId': {
      id: '/_app/requests/$requestId'
      path: '/$requestId'
      fullPath: '/requests/$requestId'
      preLoaderRoute: typeof AppRequestsRequestIdRouteImport
      parentRoute: typeof AppRequestsRouteRoute
    }
    '/_app/clients/$clientId': {
      id: '/_app/clients/$clientId'
      path: '/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AppClientsClientIdRouteImport
      parentRoute: typeof AppClientsRouteRoute
    }
  }
}

interface AppClientsRouteRouteChildren {
  AppClientsClientIdRoute: typeof AppClientsClientIdRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
}

const AppClientsRouteRouteChildren: AppClientsRouteRouteChildren = {
  AppClientsClientIdRoute: AppClientsClientIdRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
}

const AppClientsRouteRouteWithChildren = AppClientsRouteRoute._addFileChildren(
  AppClientsRouteRouteChildren,
)

interface AppRequestsRouteRouteChildren {
  AppRequestsRequestIdRoute: typeof AppRequestsRequestIdRoute
  AppRequestsIndexRoute: typeof AppRequestsIndexRoute
}

const AppRequestsRouteRouteChildren: AppRequestsRouteRouteChildren = {
  AppRequestsRequestIdRoute: AppRequestsRequestIdRoute,
  AppRequestsIndexRoute: AppRequestsIndexRoute,
}

const AppRequestsRouteRouteWithChildren =
  AppRequestsRouteRoute._addFileChildren(AppRequestsRouteRouteChildren)

interface AppSettingsRouteRouteChildren {
  AppSettingsBillingRoute: typeof AppSettingsBillingRoute
  AppSettingsIntegrationsRoute: typeof AppSettingsIntegrationsRoute
  AppSettingsMembersRoute: typeof AppSettingsMembersRoute
  AppSettingsPrivacyRoute: typeof AppSettingsPrivacyRoute
  AppSettingsShowcaseRoute: typeof AppSettingsShowcaseRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsBillingRoute: AppSettingsBillingRoute,
  AppSettingsIntegrationsRoute: AppSettingsIntegrationsRoute,
  AppSettingsMembersRoute: AppSettingsMembersRoute,
  AppSettingsPrivacyRoute: AppSettingsPrivacyRoute,
  AppSettingsShowcaseRoute: AppSettingsShowcaseRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppSignaturesRouteRouteChildren {
  AppSignaturesSplatRoute: typeof AppSignaturesSplatRoute
  AppSignaturesIndexRoute: typeof AppSignaturesIndexRoute
}

const AppSignaturesRouteRouteChildren: AppSignaturesRouteRouteChildren = {
  AppSignaturesSplatRoute: AppSignaturesSplatRoute,
  AppSignaturesIndexRoute: AppSignaturesIndexRoute,
}

const AppSignaturesRouteRouteWithChildren =
  AppSignaturesRouteRoute._addFileChildren(AppSignaturesRouteRouteChildren)

interface AppRouteRouteChildren {
  AppClientsRouteRoute: typeof AppClientsRouteRouteWithChildren
  AppRequestsRouteRoute: typeof AppRequestsRouteRouteWithChildren
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppSignaturesRouteRoute: typeof AppSignaturesRouteRouteWithChildren
  AppCalendarRoute: typeof AppCalendarRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppMessagesRoute: typeof AppMessagesRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppArtifactsIndexRoute: typeof AppArtifactsIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppClientsRouteRoute: AppClientsRouteRouteWithChildren,
  AppRequestsRouteRoute: AppRequestsRouteRouteWithChildren,
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppSignaturesRouteRoute: AppSignaturesRouteRouteWithChildren,
  AppCalendarRoute: AppCalendarRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppMessagesRoute: AppMessagesRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppArtifactsIndexRoute: AppArtifactsIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRoute: AuthRoute,
  OnboardingRoute: OnboardingRoute,
  AppSplatRoute: AppSplatRoute,
  InviteTokenRoute: InviteTokenRoute,
  AppIndexRoute: AppIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
